import { Edit } from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";
import SortIcon from "@mui/icons-material/Sort";
import ViewWeekIcon from "@mui/icons-material/ViewWeek";
import AddIcon from "@mui/icons-material/Add";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Box, Button, IconButton, Stack, Typography } from "@mui/material";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { AgGridReact } from "ag-grid-react";
import PropTypes from "prop-types";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FuelAnalysiscolumnData } from "../../common/constants/gridRowColumn";
import {
  useCompany,
  useDealer,
  useFleetList,
  useFuelAnalysis,
  useMovableColumn,
  useNewVehicle,
  useFuelPrice,
  usePagination,
  useReplacement,
  useSortableColumn,
  useUser,
} from "../../common/hooks";
import { DeleteDialog } from "../../components/DeleteDialog";
import { SearchBar } from "../../components/SearchBar";
import { layoutStyle } from "../layout-ui/style";
import { TruckLoader } from "./truckLoader";
import { useDebounce } from "../../components/useDebounce";
import {
  actionColumnFunction,
  checkFieldColumn,
  checkbox,
  ensureHeaderTooltip,
  getDefaultColDef,
  sidebarMenu,
} from "../../common/constants/commonFunction";
import { getCompanyId } from "../../common/constants/commonFunction";
import { TAB_CONTENT, TAB_VALUE } from "../../common/constants/popupMessage";
import { localStorageItemNames } from "../../common/constants";
import { PageNameConstant } from "../../common/constants/PageNameConstant";
import { PopupBlock } from "../../components/PopupBlock";
import {
  applyActiveSortToColumns,
  getActiveSortRequest,
  getActiveSortRecord,
  onSortChanged,
  sortRowsByActiveSort,
  updateGridSortState,
} from "../../common/utils/sortingColumn";
import { columnSortingMessage } from "../../common/utils/columnSortingMessage";
import { SortingTextPopup } from "../../components/SortingTextPopup";
import { DEALEAR_DEFAULT } from "../../common/constants/dealer-name";
function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </Box>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export const FuelAnalysis = () => {
  const classes = layoutStyle();
  const [page, setPage] = useState({ pageSize: 10000, page: 0 });
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [columnFinal, setColumnFinal] = useState([]);
  const [value, setValue] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const [rowDataFinal, setRowDataFinal] = useState([]);
  const [open, setOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [deleteValue, setDeleteValue] = useState();
  const { state } = useLocation();
  const navigation = useNavigate();
  const {
    getFuelAnalysisApi,
    fuelAnalysisList,
    deleteFuelAnalysisListByIdApi,
    getFuelAnalysisApiList,
    fuelListFilter,
    loading,
    setFuelListFilter,
  } = useFuelAnalysis();
  const { companyNameHeader, dealerNameHeader } = useCompany();
  const { getFuelPriceDailyUpdate } = useFuelPrice();
  const { deletFleetListByIdApi } = useFleetList();
  const {
    setSelectedNav,
    columnChange,
    setColumnChange,
    popupBlock,
    setPopupBlock,
    setSidebarColumnPopup,
  } = useUser();

  const userType = localStorage.getItem("type");
  const localUserId = localStorage.getItem(localStorageItemNames.userID);
  const defaultColDef = useMemo(
    () => ({ ...getDefaultColDef(), sortable: true }),
    []
  );
  const { setNewFleetNo } = useDealer();
  const { setToastClose } = useNewVehicle();
  const { setNewVehicle } = useNewVehicle();
  const { setReplacementList } = useReplacement();
  const [localSortedColumn, setLocalSortedColumn] = useState([]);
  const gridRef = useRef(null);
  const [movableColumnData, setMovableColumnData] = useState([]);
  const {
    movableColumn,
    getMovableColumnApi,
    createMovableColumn,
    updateViewMovableColumn,
  } = useMovableColumn();
  // Use local state for sortedColumn to prevent cross-page contamination via shared context
  const sortedColumn = localSortedColumn;
  const setSortedColumn = setLocalSortedColumn;

  const {
    getSortableColumnApi,
    sortableColumnData,
    createSortableColumn,
    updateViewSortableColumn,
  } = useSortableColumn();
  const [nextButton, setNextButton] = useState("");
  const [prevButton, setPrevButton] = useState("");

  const handleClose = () => {
    setOpen(false);
    setValue(0);
  };
  useEffect(() => {
    getMovableColumnApi({
      filter: {
        userId: localStorage.getItem(localStorageItemNames.userID),
        pageName: PageNameConstant.fuelAnalysis,
        companyId: localStorage.getItem(localStorageItemNames.companyId),
        dealerId: DEALEAR_DEFAULT.dealerId,
      },
    });

    getSortableColumnApi({
      filter: {
        userId: localStorage.getItem(localStorageItemNames.userID),
        pageName: PageNameConstant.fuelAnalysis,
        companyId: localStorage.getItem(localStorageItemNames.companyId),
        dealerId: DEALEAR_DEFAULT.dealerId,
      },
    });
    setNewFleetNo(null);
    setNewVehicle([]);
    setSidebarColumnPopup("");
    setColumnChange(false);
  }, []);
  const onCellClicked = (event) => {
    let checkField = checkFieldColumn(event);
    if (checkField) {
      handleEditButton(event?.data);
    }
  };

  const [anchorElSearch, setAnchorElSearch] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [openSortingPopup, setOpenSortingPopup] = useState(false);
  const {
    setPagination,
    setFleetPagination,
    setMaintainancePagination,
    setFuelPagination,
    setFundingPagination,
  } = usePagination();

  const onSearch = (e) => {
    debouncedSearch(e?.target?.value);
    handleClickSearch(e);
  };
  const handleClickSearch = (event) => {
    setAnchorElSearch(event.currentTarget);
  };

  const onSearchFunc = (e) => {
    setSearchValue(e[0]);
  };
  const debouncedSearch = useDebounce(onSearchFunc, 500);

  useEffect(() => {
    const sourceRows = state?.data || fuelListFilter || [];
    const filteredRows = searchValue
      ? sourceRows.filter((row) =>
          row?.fleetNo?.toLowerCase().includes(searchValue.toLowerCase())
        )
      : sourceRows;
    if (state?.data) setRows([...state.data]);
    setRowDataFinal(
      sortRowsByActiveSort(
        filteredRows,
        getActiveSortRecord(sortableColumnData)
      )
    );
  }, [fuelListFilter, state, searchValue, sortableColumnData]);

  useEffect(() => {
    if (columns?.length > 0) {
      columns?.map((item) => {
        item["width"] = 160;
        return true;
      });
    }
  }, [columns]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    return `${month}/${day}/${year}  ${hours}:${minutes}:${seconds}`;
  };
  useEffect(() => {
    const activeSort = getActiveSortRecord(sortableColumnData);
    if (activeSort && movableColumn?.length > 0) {
      let dataMovable = movableColumn[0];
      let columnParse = applyActiveSortToColumns(
        JSON.parse(dataMovable?.columnName),
        activeSort
      );
      setMovableColumnData(columnParse);
    } else if (movableColumn?.length > 0) {
      let dataMovable = movableColumn[0];
      let columnParse = JSON.parse(dataMovable?.columnName);
      setMovableColumnData(
        applyActiveSortToColumns(columnParse, activeSort)
      );
    } else {
      const actionColumn = actionColumnFunction({
        selectedRows: selectedRows,
        handleEditButton: handleEditButton,
        handleDeleteButton: handleDeleteButton,
        deleteButton: true,
      });

      const dateColumn = {
        field: "date",
        headerName: "Date",
        minWidth: 160,
        valueFormatter: (params) => formatDate(params.value),
      };
      setMovableColumnData([
        checkbox,
        ...applyActiveSortToColumns(FuelAnalysiscolumnData, activeSort),
        dateColumn,
        actionColumn,
      ]);
    }
  }, [FuelAnalysiscolumnData, movableColumn, sortableColumnData]);

  useEffect(() => {
    if (movableColumnData) {
      setColumnFinal([...movableColumnData]);
    }
  }, [movableColumnData]);

  const handleAddButton = () => {
    navigation("/new-fleetlist", {
      state: {
        tabValue: TAB_VALUE.FLEET_LIST,
        selectedContent: TAB_CONTENT.FLEET_LIST,
      },
    });
  };
  const handleEditButton = (params) => {
    navigation("/new-fleetlist", {
      state: {
        tabValue: TAB_VALUE.FUEL_ANALYSIS,
        selectedContent: TAB_CONTENT.FUEL_ANALYSIS,
        data: params,
      },
    });
  };
  const handleDeleteButton = async (values) => {
    setDeleteOpen(true);
    setDeleteValue({
      id: values?.id ?? values?.fuelAnalysisId ?? values?.fuelId ?? values,
      fleetId: values?.fleetId,
      companyId: getCompanyId(userType, companyNameHeader),
      dealerId: DEALEAR_DEFAULT.dealerId,
      userId: localUserId,
    });
  };

  const handleDelete = async () => {
    const companyId = deleteValue?.companyId ?? getCompanyId(userType, companyNameHeader);
    const dealerId = deleteValue?.dealerId ?? DEALEAR_DEFAULT.dealerId;
    const userId = deleteValue?.userId ?? localUserId;
    let payload = {
      id: deleteValue?.id,
      companyId: companyId,
      dealerId,
      userId,
    };
    await deleteFuelAnalysisListByIdApi(payload);

    if (deleteValue?.fleetId) {
      await deletFleetListByIdApi({
        id: deleteValue.fleetId,
        companyId,
        dealerId,
        userId,
      });
    }
    setDeleteOpen(false);
    setDeleteValue(null);
  };
  useEffect(() => {
    setToastClose(false);
    getMovableColumnApi({
      filter: {
        userId: localStorage.getItem(localStorageItemNames.userID),
        pageName: PageNameConstant.fuelAnalysis,
        companyId: localStorage.getItem(localStorageItemNames.companyId),
        dealerId: DEALEAR_DEFAULT.dealerId,
      },
    });

    if (companyNameHeader) {
      const companyId = getCompanyId(userType, companyNameHeader);
      const refreshFuelPricesAndLoadAnalysis = async () => {
        await getFuelPriceDailyUpdate();
        const sortResponse = await getSortableColumnApi({
          filter: {
            userId: localStorage.getItem(localStorageItemNames.userID),
            pageName: PageNameConstant.fuelAnalysis,
            companyId: localStorage.getItem(localStorageItemNames.companyId),
            dealerId: DEALEAR_DEFAULT.dealerId,
          },
        });
        await getFuelAnalysisApiList({
          fleetNo: "",
          companyId: companyId,
          dealerId: DEALEAR_DEFAULT.dealerId,
          userId: localUserId,
          ...getActiveSortRequest(sortResponse),
        });
      };
      refreshFuelPricesAndLoadAnalysis();
    } else {
      getSortableColumnApi({
        filter: {
          userId: localStorage.getItem(localStorageItemNames.userID),
          pageName: PageNameConstant.fuelAnalysis,
          companyId: localStorage.getItem(localStorageItemNames.companyId),
          dealerId: DEALEAR_DEFAULT.dealerId,
        },
      });
      setFuelListFilter([]);
    }
  }, [companyNameHeader]);

  useEffect(() => {
    setPagination(0);
    setFleetPagination(0);
    setMaintainancePagination(0);
    setFuelPagination(0);
    setFundingPagination(0);
    setReplacementList([]);
    // getFuelAnalysisApi();
  }, []);

  const handleNext = (event) => {
    if (columnChange) {
      setPopupBlock(true);
      setNextButton("/recommended-acquisition-strategy");
    } else {
      setSelectedNav(sidebarMenu.newVehicle);
      navigation("/recommended-acquisition-strategy");
    }
  };
  const handleBack = () => {
    if (columnChange) {
      setPopupBlock(true);
      setPrevButton("/maintenance-repair-cost-comparison");
    } else {
      setSelectedNav(sidebarMenu.maintenance);
      navigation("/maintenance-repair-cost-comparison");
    }
  };
  const handleMovableColumn = async () => {
    const cols = gridRef.current?.api?.getAllGridColumns();
    const colNamesIndex = cols?.map((items, index) => items?.colDef);
    setMovableColumnData(colNamesIndex);
    if (movableColumn?.length > 0) {
      await updateViewMovableColumn({
        userId: localStorage.getItem(localStorageItemNames.userID),
        pageName: PageNameConstant.fuelAnalysis,
        ColumnName: JSON.stringify(colNamesIndex),
        id: movableColumn[0]?.id,
        companyId: localStorage.getItem(localStorageItemNames.companyId),
        dealerId: DEALEAR_DEFAULT.dealerId,
      });
    } else {
      await createMovableColumn({
        userId: localStorage.getItem(localStorageItemNames.userID),
        pageName: PageNameConstant.fuelAnalysis,
        ColumnName: JSON.stringify(colNamesIndex),
        companyId: localStorage.getItem(localStorageItemNames.companyId),
        dealerId: DEALEAR_DEFAULT.dealerId,
      });
    }
    setColumnChange(false);
  };
  const handleColumnChange = (event) => {
    if (event?.column) {
      const cols = gridRef.current?.api?.getAllGridColumns();
      const colNamesIndex = cols?.map((items, index) => items?.colDef);
      setMovableColumnData(colNamesIndex);
      setColumnChange(true);
    }
  };
  const onSortedColumnChange = () =>
    updateGridSortState(gridRef, setSortedColumn, setColumnFinal);
  const onSortedColumnChangeAlready = async () => {
    if (sortableColumnData?.length) {
      setOpenSortingPopup(true);
      return;
    }
    await onSortChanged(
      gridRef,
      setSortedColumn,
      setColumnFinal,
      sortableColumnData,
      createSortableColumn,
      updateViewSortableColumn,
      PageNameConstant.fuelAnalysis
    );
  };
  return (
    <Box className={classes.mainContent}>
      <CustomTabPanel value={value} index={0}>
        <Box className={classes.gridContantFleetList}>
          <Stack
            direction="row"
            sx={{ justifyContent: "space-between", alignItems: "center" }}
          >
            <Box className={classes.headerNameText}>Fuel Economy Comparison</Box>
            <Box className={classes.sortingFieldText}>
              {columnSortingMessage(sortableColumnData)}
            </Box>
          </Stack>
          <Stack
            direction="row"
            sx={{ justifyContent: "space-between", alignItems: "center" }}
          >
            <Box className={classes.headerNameText}></Box>
            <Box className={classes.addEditGrid}>
              {getActiveSortRecord(sortableColumnData) ? (
                <Button
                  variant="contained"
                  className={classes.replacementButtonAction}
                  onClick={onSortedColumnChangeAlready}
                  startIcon={<SortIcon style={{ fontSize: 15 }} />}
                >
                  <span style={{ fontSize: 12 }}>Save Sort</span>
                </Button>
              ) : (
                <Button
                  variant="contained"
                  className={classes.replacementButtonAction}
                  onClick={onSortedColumnChangeAlready}
                  startIcon={<SortIcon style={{ fontSize: 15 }} />}
                >
                  <span style={{ fontSize: 12 }}>Save Sort</span>
                </Button>
              )}
              <Button
                variant="contained"
                className={classes.replacementButtonAction}
                onClick={handleMovableColumn}
                startIcon={<ViewWeekIcon style={{ fontSize: 15 }} />}
              >
                <span style={{ fontSize: 12 }}>Save Columns</span>
              </Button>
              <Button
                variant="outlined"
                className={classes.replacementButtonSecondary}
                onClick={handleBack}
                startIcon={<ArrowBackIcon style={{ fontSize: 15 }} />}
              >
                <span style={{ fontSize: 12 }}>Back</span>
              </Button>
              <Button
                variant="contained"
                className={classes.replacementButtonPrimary}
                onClick={handleNext}
                endIcon={<ArrowForwardIcon style={{ fontSize: 15 }} />}
              >
                <span style={{ fontSize: 12 }}>Next</span>
              </Button>
              <Button
                variant="contained"
                className={classes.replacementButtonSuccess}
                onClick={handleAddButton}
                startIcon={<AddIcon style={{ fontSize: 15 }} />}
              >
                NEW
              </Button>
              <SearchBar onSearch={onSearch} />
            </Box>
          </Stack>
          {loading ? (
            <TruckLoader />
          ) : (
            <AgGridReact
              ref={gridRef}
              className="ag-theme-quartz"
              rowSelection="multiple"
              onSelectionChanged={(event) => {
                const selectedNodes = event.api.getSelectedNodes();
                const selectedRows = selectedNodes.map((node) => node.data);
                setSelectedRows(selectedRows);
              }}
              suppressRowClickSelection
              pagination={true}
              rowData={rowDataFinal}
              defaultColDef={defaultColDef}
              checkboxSelection
              columnDefs={ensureHeaderTooltip(columnFinal)}
              onCellClicked={onCellClicked}
              onColumnMoved={handleColumnChange}
              onSortChanged={onSortedColumnChange}
            />
          )}
        </Box>
      </CustomTabPanel>
      {deleteOpen && (
        <DeleteDialog
          open={deleteOpen}
          setOpen={() => setDeleteOpen(false)}
          deleteApi={() => handleDelete()}
        />
      )}
      {popupBlock && (
        <PopupBlock
          open={popupBlock}
          setOpen={() => setPopupBlock(false)}
          navigationRouteNext={nextButton}
          navigationRoutePrev={prevButton}
          selectedNavStyle={
            nextButton ? sidebarMenu.newVehicle : sidebarMenu.maintenance
          }
          columnChangeData={movableColumnData}
          pageName={PageNameConstant.fuelAnalysis}
        />
      )}
      {openSortingPopup && (
        <SortingTextPopup
          open={openSortingPopup}
          setOpen={setOpenSortingPopup}
          gridRef={gridRef}
          setSortedColumn={setSortedColumn}
          setColumnFinal={setColumnFinal}
          columnFinal={columnFinal}
          sortableColumnData={sortableColumnData}
          createSortableColumn={createSortableColumn}
          updateViewSortableColumn={updateViewSortableColumn}
          pageName={PageNameConstant.fuelAnalysis}
        />
      )}
    </Box>
  );
};
